module.exports = __webpack_public_path__ + "static/media/internet-of-things11.43752ed0.png";